import React from "react";
import { Card, Button, Badge } from "react-bootstrap";
import {
  IconFileText,
  IconPlus,
  IconEdit,
  IconTrash,
} from "@tabler/icons-react";
import PermissionMiddleware from "middleware/PermissionMiddleware";

const MaintenanceHistoryCard = ({
  services,
  onAddService,
  onEditService,
  onDeleteService,
}) => {
  return (
    <Card>
      <Card.Header>
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "600",
            margin: "0",
            color: "#1f2937",
          }}
        >
          Riwayat Maintenance
        </h3>
      </Card.Header>
      <Card.Body>
        {services.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "48px",
              color: "#6b7280",
            }}
          >
            <IconFileText size={48} style={{ marginBottom: "16px" }} />
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "600",
                marginBottom: "8px",
                color: "#374151",
              }}
            >
              Belum ada riwayat service
            </h3>
            <p style={{ marginBottom: "16px" }}>
              Kendaraan ini belum pernah dilakukan service
            </p>
            <Button
              style={{
                backgroundColor: "#2563eb",
                border: "none",
              }}
              onClick={onAddService}
            >
              <IconPlus size={16} style={{ marginRight: "8px" }} />
              Tambah Service Baru
            </Button>
          </div>
        ) : (
          <div style={{ display: "grid", gap: "16px" }}>
            {services.map((service) => (
              <Card
                key={service.id}
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                }}
              >
                <Card.Body style={{ padding: "16px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "12px",
                    }}
                  >
                    <div>
                      <h5
                        style={{
                          margin: "0 0 4px 0",
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#1f2937",
                        }}
                      >
                        Service -{" "}
                        {new Date(service.service_date).toLocaleDateString(
                          "id-ID",
                        )}
                      </h5>
                      <p
                        style={{
                          margin: "0",
                          color: "#6b7280",
                          fontSize: "14px",
                        }}
                      >
                        Mekanik: {service.mechanic?.name || "Tidak diketahui"}
                      </p>
                    </div>
                    <div className="d-flex flex-column align-items-end gap-2">
                      <Badge bg="success" text="white" className="fs-6">
                        Selesai
                      </Badge>
                      <div className="d-flex gap-1">
                        <PermissionMiddleware
                          allowedPermissions={["edit_service"]}
                        >
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="d-flex align-items-center gap-1"
                            onClick={() => onEditService(service)}
                          >
                            <IconEdit size={14} />
                            Edit
                          </Button>
                        </PermissionMiddleware>

                        <PermissionMiddleware allowedRoles={["superadmin"]}>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            className="d-flex align-items-center gap-1"
                            onClick={() => onDeleteService(service)}
                          >
                            <IconTrash size={14} />
                            Delete
                          </Button>
                        </PermissionMiddleware>
                      </div>
                    </div>
                  </div>

                  <p
                    style={{
                      margin: "0 0 12px 0",
                      color: "#374151",
                      fontSize: "14px",
                    }}
                  >
                    {service.description}
                  </p>

                  <div
                    style={{
                      borderTop: "1px solid #e5e7eb",
                      paddingTop: "12px",
                    }}
                  >
                    <h6
                      style={{
                        margin: "0 0 8px 0",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#374151",
                      }}
                    >
                      Item Service:
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "6px",
                      }}
                    >
                      {service.service_items?.map((item, index) => (
                        <Badge
                          key={index}
                          bg="secondary"
                          text="white"
                          style={{ fontSize: "12px" }}
                        >
                          {item.item_name} ({item.quantity} {item.unit})
                        </Badge>
                      ))}
                    </div>
                  </div>

                  {service.next_service && (
                    <div
                      style={{
                        marginTop: "12px",
                        paddingTop: "12px",
                        borderTop: "1px solid #e5e7eb",
                      }}
                    >
                      <p
                        style={{
                          margin: "0",
                          fontSize: "12px",
                          color: "#6b7280",
                        }}
                      >
                        <strong>Service berikutnya:</strong>{" "}
                        {new Date(service.next_service).toLocaleDateString(
                          "id-ID",
                        )}
                      </p>
                    </div>
                  )}
                </Card.Body>
              </Card>
            ))}

            <div style={{ textAlign: "center", marginTop: "16px" }}>
              <Button
                style={{
                  backgroundColor: "#059669",
                  border: "none",
                }}
                onClick={onAddService}
              >
                <IconPlus size={16} style={{ marginRight: "8px" }} />
                Tambah Service Baru
              </Button>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default MaintenanceHistoryCard;
